{
  "DEV_customerPortalFirebaseConfig": {
    "apiKey": "AIzaSyB81pssKNjPIKQZBLxhp3EVGzGKktRHVrM",
    "authDomain": "tmm19482025.firebaseapp.com",
    "projectId": "tmm19482025",
    "storageBucket": "tmm19482025.firebasestorage.app",
    "messagingSenderId": "291547781206",
    "appId": "1:291547781206:web:ffd4029c507714ca2c03f7",
    "measurementId": "G-B71C0RT1R1"
  },
  "DEV_adminPortalFirebaseConfig": {
    "apiKey": "AIzaSyB81pssKNjPIKQZBLxhp3EVGzGKktRHVrM",
    "authDomain": "tmm19482025.firebaseapp.com",
    "projectId": "tmm19482025",
    "storageBucket": "tmm19482025.firebasestorage.app",
    "messagingSenderId": "291547781206",
    "appId": "1:291547781206:web:c3eec89460d460132c03f7",
    "measurementId": "G-QS232WL1Z6"
  },
  "PROD_adminPortalFirebaseConfig": {
    "apiKey": "AIzaSyAKs-q3Cf1ditnyqk4vWibLN4kE0HWnHT8",
    "authDomain": "the-miles-market.firebaseapp.com",
    "projectId": "the-miles-market",
    "storageBucket": "the-miles-market.firebasestorage.app",
    "messagingSenderId": "635096214080",
    "appId": "1:635096214080:web:c205f37851bf34862c8da5",
    "measurementId": "G-0MBFL01B13"
  },
  "PROD_customerPortalFirebaseConfig": {
    "apiKey": "AIzaSyAKs-q3Cf1ditnyqk4vWibLN4kE0HWnHT8",
    "authDomain": "the-miles-market.firebaseapp.com",
    "projectId": "the-miles-market",
    "storageBucket": "the-miles-market.firebasestorage.app",
    "messagingSenderId": "635096214080",
    "appId": "1:635096214080:web:9d2261626e1138082c8da5",
    "measurementId": "G-K9JQDN3TCB"
  }
}
